import axios from 'axios';
import { getBaseUrl } from "../../service/apiUrl";
const { createSlice, createAsyncThunk } = require('@reduxjs/toolkit');

export const STATUSES = Object.freeze({
    IDLE: 'idle',
    ERROR: 'error',
    LOADING: 'loading',
});

const getLeaderBoard = createSlice({
    name: 'LeaderBoard',
    initialState: {
        data: [],
        status: STATUSES.IDLE,
    },

    extraReducers: (builder) => {
        builder
            .addCase(fetchLeaderBoard.pending, (state, action) => {
                state.status = STATUSES.LOADING;
            })
            .addCase(fetchLeaderBoard.fulfilled, (state, action) => {
                state.data = action.payload;
                state.status = STATUSES.IDLE;
            })
            .addCase(fetchLeaderBoard.rejected, (state, action) => {
                state.status = STATUSES.ERROR;
            });
    },
});

export const { setLeaderBoard, setStatus } = getLeaderBoard.actions;
export default getLeaderBoard.reducer;

export const fetchLeaderBoard = createAsyncThunk('competition-v2/leaderboard/fetch', async () => {
    const res = await axios.get(`${getBaseUrl()}/competition-v2/leaderboard`)
    const data = res.data;
    return data.data;
});


